import { Controller } from '@hotwired/stimulus'
import * as focusTrap from 'focus-trap';

var trap;

export default class extends Controller {
  static targets = ['modal']

  connect() {
    trap = focusTrap.createFocusTrap(this.modalTarget, {
      allowOutsideClick: true,
    })
    trap.activate()
  }

  disconnect() {
    trap.deactivate()
  }
}